
module.exports = {
	Generator: require('./src/jsCalendar'),
	addLabels: require('./src/addLabels')
}



//////////////////
// WEBPACK FOOTER
// ../~/js-calendar/index.js
// module id = 248
// module chunks = 0